// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################


export const UZIVATEL = 'UZIVATEL';

export const SPRAVSPOL = 'SPRAVSPOL';

export const OPERATOR = 'OPERATOR';

export const ADMIN = 'ADMIN';

/**
 * Seznam všech hodnot.
 */
export const values = [
    UZIVATEL,
    SPRAVSPOL,
    OPERATOR,
    ADMIN
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [UZIVATEL]: {caption: ''},
    [SPRAVSPOL]: {caption: ''},
    [OPERATOR]: {caption: ''},
    [ADMIN]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}